<template>
  <li class="item">
    <strong class="label">
      {{ Utils.codeNm(CODE_GOODS_FILE_SE_CD, props.file.goodsFileSeCd) }}
    </strong>
    <a :href="fileUrl" class="subject" target="_blank" :download="true">
      {{ cmUtil.sanitizeHTML2(props.file.orgnlFileNm) }}
    </a>
    <div class="buttons">
      <button
        type="button"
        class="c-btn-share"
        ref="shareButtonRef"
        @mouseenter="onShareButtonOver"
        @mouseleave="() => (isShowSharePopover = false)"
        @click="showShareSelectPop(props.file)"
      >
        <span class="sr-only">공유하기</span>
      </button>
      <!-- D:  over시 popover 노출하기 위해 꼭 버튼 형제로 위치시켜야함 -->
      <div
        v-if="!isMobile"
        class="c-popover-detail type-small"
        :class="{ 'is-active': isShowSharePopover }"
        :style="{
          position: 'fixed',
          top: sharePopoverStyle.top + 'px',
          left: sharePopoverStyle.left + 'px',
        }"
      >
        <div class="text">공유하기</div>
      </div>
      <button
        type="button"
        class="c-btn-kakao"
        ref="kakaoButtonRef"
        @mouseenter="onKakaoButtonOver"
        @mouseleave="() => (isShowKakaoPopover = false)"
        @click="onKakaoButtonClick"
      >
        <span class="sr-only">카카오톡 공유하기</span>
      </button>
      <!-- D:  over시 popover 노출하기 위해 꼭 버튼 형제로 위치시켜야함 -->
      <div
        v-if="!isMobile"
        class="c-popover-detail type-small"
        :class="{ 'is-active': isShowKakaoPopover }"
        :style="{
          position: 'fixed',
          top: kakaoPopoverStyle.top + 'px',
          left: kakaoPopoverStyle.left + 'px',
        }"
      >
        <div class="text">카카오톡 공유</div>
      </div>
    </div>
  </li>
</template>
<script setup>
import { defineProps, onMounted, inject, ref, computed } from "vue";
import Utils from "@/js/utils";
import * as cmUtil from "@/utils/cmUtil.js";

const { isMobile } = cmUtil.useDeviceType();

const CODE_GOODS_FILE_SE_CD = inject("CODE_GOODS_FILE_SE_CD");
const showShareSelectPop = inject("showShareSelectPop");
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;

// const emits = defineEmits(["selectPop"]);

const props = defineProps({
  file: {
    type: Object,
    required: true,
  },
});

const shareButtonRef = ref();
const kakaoButtonRef = ref();

const isShowSharePopover = ref(false);
const isShowKakaoPopover = ref(false);

const sharePopoverStyle = ref({
  top: 555,
  left: 940,
});

const kakaoPopoverStyle = ref({
  top: 555,
  left: 940,
});

// const kakaoPopoverStyle = ref({
//   top: 555,
//   left: 963,
// });
onMounted(() => {
  onShareButtonOver();
});

const fileUrl = computed(() => {
  return props.file.filePath.startsWith("http")
    ? props.file.filePath
    : FILE_CDN_URL + props.file.filePath + "/" + props.file.physFileNm;
});

const onShareButtonOver = () => {
  sharePopoverStyle.value.top =
    shareButtonRef.value.getBoundingClientRect().top - 51;
  sharePopoverStyle.value.left =
    shareButtonRef.value.getBoundingClientRect().left - 19;

  isShowSharePopover.value = true;
};

const onKakaoButtonOver = () => {
  kakaoPopoverStyle.value.top =
    kakaoButtonRef.value.getBoundingClientRect().top - 51;
  kakaoPopoverStyle.value.left =
    kakaoButtonRef.value.getBoundingClientRect().left - 34;

  isShowKakaoPopover.value = true;
};

const onKakaoButtonClick = async () => {
  if (!(await cmUtil.confirm("", { type: "kakao" }))) {
    return;
  }
  if (window.Kakao) {
    window.Kakao.Link.sendDefault({
      objectType: "feed",
      content: {
        title: cmUtil.sanitizeHTML2(props.file.orgnlFileNm),
        imageUrl: fileUrl.value, // 공유할 이미지 URL
        link: {
          mobileWebUrl: fileUrl.value,
          webUrl: fileUrl.value,
        },
      },
    });
  }
};
</script>
